import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import {  productdata } from './data';
import Carousel from './Carousel';
import BackButton2 from './Backbutton2';

const ProductsDetails = () => {
    const [data1,setdata]=useState(productdata)
    const { productId } = useParams();
    const useridx=parseInt(productId)
    const currentData=data1.find(item=>item.id===useridx)
  return (
    <div>
    
    <div className="product-details-page">
      {/* Large Product Image */}
      <div className="product-image-container">
        <img
          src={currentData.image}
          alt="Product Image"
          className="product-image"
          
        /><BackButton2/>
      </div>
      <br/>
      <br/>

      {/* Product Name Heading */}
      <h2 className="product-name">{currentData.name}</h2>

      {/* Small Product Image */}
      <div className="small-product-image-container">
        <img
          src={currentData.image}
          alt="Small Product Image"
          className="small-product-image"
        />
      </div>
      <p><strong>Note:</strong>{currentData.about}</p>

      {/* Product Details Table */}
      <div className="product-details-table-container">
        <table className="product-details-table">
          <thead>
            <tr>
              <th style={{ backgroundColor: '#ff9900' }}>Title of the Product</th>
              <th style={{ backgroundColor: '#ff9900' }}>Type</th>
              <th style={{ backgroundColor: '#ff9900' }}>Origin</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{currentData.name}</td>
              <td>{currentData.type}</td>
              <td>{currentData.origin}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div></div>
  );
};

export default ProductsDetails;
